"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteLineSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class RequestForQuoteLineSearchResponse extends common_1.PaginatedResponse {
}
exports.RequestForQuoteLineSearchResponse = RequestForQuoteLineSearchResponse;
//# sourceMappingURL=request-for-quote-line-search.response.js.map